module.exports = __webpack_public_path__ + "static/media/applenav-support.c62453ac.PNG";